import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";

import { GetStakingRiskProductsUserInfoThunk } from "../../../Thunks/StakingRiskThunk";
import { formatStakingCurrency } from "../../../Utils/helper";

import styles from "../StakingRiskDetails/staking-risk.module.css";
import { renderClassName } from "./helper";

export const StakingCardLeft = ({ activeId, setActiveId, containerRef, zoomActive }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetStakingRiskProductsUserInfoThunk({ selected: true }));
  }, []);

  const products = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskProductsListUserInfo;
  });

  useEffect(() => {
    if (products?.length > 0) {
      setActiveId(activeId || products[0].id);
    }
  }, [products, setActiveId]);

  return (
    <div className={styles["staking-risk-content"]}>
      {products.map((product) => {
        const { id, stakingRisk } = product;
        const name = stakingRisk?.name || "Unnamed";
        const safety_index = stakingRisk.safetyIndex;

        return (
          <div key={id} >
            <div
              className={`${styles["staking-risk-details-left-item"]}  ${activeId === id
                ? zoomActive === 'true'
                  ? styles["active-zoom"]
                  : styles["active"]
                : ""
                }`}
              onClick={() => {
                sessionStorage.setItem("stakingRiskScrollY", 0);
                setActiveId(id);
                navigate(`/staking-risk/details/${id}`, {
                  state: { selectedProduct: null },
                });
                if (containerRef.current) {
                  containerRef.current.scroll({
                    top: 0,
                    behavior: "smooth"
                  });
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <div className={styles["staking-risk-details-left-item-content"]}>
                <p className={styles["staking-risk-details-left-item-title"]}>{name}</p>
                <p className={styles["staking-risk-details-left-item-total"]}>
                  Staked Amount:{" "}<br />
                  <span className={styles["staking-risk-details-left-item-total-percent"]} >
                    {formatStakingCurrency(product.stakedAmount)}
                  </span>
                </p>
              </div>
              <div className={styles["card_after"]}>
                <div className="card__risk__chart" style={{ position: "relative", top: "0px", marginTop: "5px", width: "90px", height: "90px" }}>
                  <CircularProgressBar
                    {...renderClassName(stakingRisk?.safetyIndex)?.props}
                  >
                    <div className="card__round__shadow" style={{ width: "68px", height: "68px" }}></div>
                    <div className="card__risk__chart__min__wrapper">
                      <p
                        className="card__risk__chart__number"
                        style={{
                          color: renderClassName(stakingRisk?.safetyIndex)
                            ?.color,
                          position: "relative", top: "-10px"
                        }}
                      >
                        {Math.round(safety_index)}
                      </p>

                    </div>
                  </CircularProgressBar>
                </div>
              </div>
            </div>
            <div className={styles["divider"]}></div>
          </div >
        );
      })}
    </div>
  );
};